import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static targets = ["kind", "tutorCategory", "optionsList", "staticText"];
    connect() {
        // make select2 work in questions
        const event = new Event('init_select2', {bubbles: true})
        document.dispatchEvent(event)
        // show / hide optional inputs
        this.fix_optional_input()
        const kind = $(this.kindTarget).find("select")
        kind.on("change", () => {
            this.fix_optional_input()
        })
    }

    fix_optional_input() {
        const kind = $(this.kindTarget).find("select")
        $(this.tutorCategoryTarget).hide()
        $(this.optionsListTarget).hide()
        $(this.staticTextTarget).hide()

        switch (kind.val()) {
            case "tutor":
                $(this.tutorCategoryTarget).show()
                break
            case "radio_select":
                $(this.optionsListTarget).show()
                break
            case "static_text":
                $(this.staticTextTarget).show()
                break
        }
    }
}